import { matchPath, NavLink, useLocation, useParams } from "react-router-dom";

import { Breadcrumbs } from "ui/breadcrumbs";
import { Tab, Tabs } from "ui/tabs";

import { hasCampaignTemplateInstance } from "containers/admin/clients/campaign/campaign-template-instance.utils";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";

import { getCampaignPaths, getClientPaths } from "utilities/app-routes";

const CampaignPageHeader = () => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const { clientId, campaignId } = useParams<{ clientId: string; campaignId: string }>();
  const { pathname } = useLocation();

  const { clientCampaignsPath } = getClientPaths({ clientId });
  const { campaignCreativePath, campaignSettingsPath, campaignStrategyPath } = getCampaignPaths({
    clientId,
    campaignId,
  });
  const showStrategyTab = hasCampaignTemplateInstance(currentCampaign);

  // Creative matches its index only: its folder and touchpoint pages sit under the same path.
  const tabs = [
    { value: "creative", label: "Creative", to: campaignCreativePath, end: true },
    showStrategyTab
      ? { value: "strategy", label: "Strategy", to: campaignStrategyPath, end: false }
      : { value: "settings", label: "Settings", to: campaignSettingsPath, end: false },
  ];
  const selectedTab = tabs.find(({ to, end }) => matchPath({ path: to, end }, pathname))?.value ?? false;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Breadcrumbs
          breadcrumbs={[
            { label: currentClient?.name, href: clientCampaignsPath },
            { label: "Campaigns", href: clientCampaignsPath },
            { label: currentCampaign?.name, active: true },
          ]}
        />
      </div>
      <Tabs appearance="sub-nav" value={selectedTab} aria-label="Campaign">
        {tabs.map(({ value, label, to }) => (
          <Tab key={value} value={value} label={label} component={NavLink} to={to} />
        ))}
      </Tabs>
    </div>
  );
};

export default CampaignPageHeader;
